export const IsotopeSchema = () => {
  return {
    title: 'Filter',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['rooturl', 'default_tags'],
      },
    ],

    properties: {
      rooturl: {
        title: 'Url',
        description: 'Start Url für die Personen',
        widget: 'internal_url',
        required: true,
      },
    },
    required: [],
  };
};

export default IsotopeSchema;